import React from 'react';
import './style.css'
import { NavLink } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css'
import 'swiper/css/navigation';
import useSWR from 'swr';
import fetcher from '../../utils/fetcher';
import moment from 'moment';
import 'moment/locale/ko';

const FeaturedStoryCards = () => {
  const url = 'https://api.testworks.co.kr'
  const { data: featuredStoryDatas } = useSWR('https://api.testworks.co.kr/featured-stories?_sort=set_day:DESC', fetcher)

  return (
    <section className='featured-storylist'>
      <Swiper
        modules={[Navigation]}
        centeredSlides={false}
        grabCursor={true}
        navigation={true}
        slidesPerView={1.2}
        slidesPerGroup={1}
        initialSlide={1}
        className='swiper-wrapper'
        breakpoints={{
          540: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          750: {
            slidesPerView: 2,
            slidesPerGroup: 1,
          },
          1100: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            initialSlide: 1
          }
        }}
      >
        {featuredStoryDatas && (
          featuredStoryDatas.map((data) => {
              if (data.showhome) {
                  return (
                      <SwiperSlide key={data.id}>
                          <a href={data.body}
                             className='story-link'
                             style={{
                                 backgroundImage: `url(${url + data.thumbnail.url})`,
                             }}>
                              <div className='story-info'>
                                  <span className='story-title'>{data.title}</span>
                                  <div className='story-date'>
                                      <div></div>
                                      <span>{moment(data.set_day).format('YYYY.MM.DD')}</span>
                                  </div>
                              </div>
                          </a>
                      </SwiperSlide>
                  )} else {
                  return null;
              }
          })
        )}
        <SwiperSlide
          className='to-storiesroom'>
          <NavLink to='/storiesroom'
            style={{ textDecoration: 'none' }}
            className='story-link'>
            <div className='story-btn'></div>
          </NavLink>
        </SwiperSlide>

      </Swiper>
    </section>
  )
}
export default FeaturedStoryCards;